// extracted by mini-css-extract-plugin
module.exports = {"errorsList":"ErrorsMsg_errorsList__tBnZP","errors":"ErrorsMsg_errors__3-lYR"};